import { z } from 'zod/v3';
import {
  AlgorithmMetadataSnapshot,
  parseAlgorithmMetadataSnapshot,
} from './parseAlgorithmMetadataSnapshot';

export type { AlgorithmMetadataSnapshot } from './parseAlgorithmMetadataSnapshot';

const DataObjectVersionMetadataVersionBaseSchema = z.object({
  id: z.number(),
  refId: z.number(),
  code: z.string().nullish(),
  snapshot: z.string(),
  type: z.string(),
  schemaVersion: z.number(),
  hash: z.string(),
  latest: z.boolean(),
});

const parseSnapshot = ({
  snapshot,
  type,
  schemaVersion,
}: z.infer<
  typeof DataObjectVersionMetadataVersionBaseSchema
>): AlgorithmMetadataSnapshot => {
  let raw: unknown;
  try {
    raw = JSON.parse(snapshot);
  } catch {
    return { status: 'unavailable' };
  }

  if (type !== 'ALGORITHM') {
    return { status: 'unavailable' };
  }

  return parseAlgorithmMetadataSnapshot(raw, schemaVersion);
};

export const DataObjectVersionMetadataVersionSchema =
  DataObjectVersionMetadataVersionBaseSchema.transform((metadataVersion) => ({
    ...metadataVersion,
    snapshot: parseSnapshot(metadataVersion),
  }));

export type DataObjectVersionMetadataVersionType = z.output<
  typeof DataObjectVersionMetadataVersionSchema
>;
